module.exports = __webpack_public_path__ + "2acdf6b5643e34d850a628fb73f2d047.pdf";